import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { CommissionsCreate } from './CommissionsCreate/CommissionsCreate';
import { CommissionsEdit } from './CommissionsEdit/CommissionsEdit';
import { CommissionsList } from './CommissionsList/CommissionsList';
import { CommissionsShow } from './CommissionsShow/CommissionsShow';

export const commissionsResource: ResourceProps = {
  name: Resources.Commissions,
  create: CommissionsCreate,
  edit: CommissionsEdit,
  list: CommissionsList,
  show: CommissionsShow,
};
